/* AEVORA — ajout au panier AJAX + panier tiroir maison.

   Pourquoi un tiroir maison plutot que celui du theme : la section
   aevora-landing postait le formulaire nativement vers /cart/add, ce qui
   rechargeait la page et faisait perdre l'evenement product_added_to_cart
   du Web Pixel (donc presque aucun AddToCart cote Meta). Le tiroir du theme
   n'offre par ailleurs ni barre de progression, ni upsell, ni code promo.

   Le tiroir du theme est neutralise (masque + referme) plutot qu'intercepte :
   son bouton passe par la liaison declarative on:click de Horizon, dont
   l'ecouteur delegue peut s'executer avant le notre. preventDefault ne suffit
   donc pas — les deux tiroirs s'ouvraient l'un apres l'autre.

   Paliers : bases sur les remises REELLEMENT actives de la boutique
   (livraison offerte des 79 EUR, et 2e kit a -15 % via la remise automatique
   « 2e kit a -15 % »). Aucun palier 10/15/20 % n'existe cote Shopify : l'afficher
   promettrait une reduction qui ne s'appliquerait pas au paiement.

   Upsell : Le Mini Marteau est epingle en premier (accessoire a forte marge,
   demande metier). Le reste vient de l'intent « complementary », qui exige
   l'app Search & Discovery et renvoie vide ici, d'ou le repli sur « related ».

   Images : pas de loading="lazy" ici. Le panneau est insere hors viewport
   (translateX 101%), donc Chrome differe indefiniment les images lazy et le
   tiroir s'ouvrait avec des vignettes vides. */
(function () {
  var d = document;
  var FREE_SHIP = 7900;
  var BUNDLE_QTY = 2;
  var PIN = 'mini-marteau';
  var PAY = ['Visa', 'Mastercard', 'Amex', 'PayPal', 'Apple Pay', 'Klarna'];

  var CSS = [
    'theme-drawer#cart-drawer{display:none!important}',
    '.avc-ov{position:fixed;inset:0;background:rgba(40,20,14,.45);opacity:0;pointer-events:none;transition:opacity .25s;z-index:2147483000}',
    '.avc-ov.is-on{opacity:1;pointer-events:auto}',
    '.avc{position:fixed;top:0;right:0;bottom:0;width:min(430px,100vw);background:#FDF6F1;display:flex;flex-direction:column;transform:translateX(101%);transition:transform .3s cubic-bezier(.16,1,.3,1);z-index:2147483001;font-family:inherit}',
    '.avc.is-on{transform:none}',
    '@media (max-width:767px){.avc{width:100vw}}',
    '.avc-hd{display:flex;align-items:center;justify-content:center;padding:16px 52px 12px;position:relative;flex:0 0 auto}',
    '.avc-hd h2{margin:0;font-size:21px;font-weight:800;color:#5C3A2E}',
    '.avc-x{position:absolute;right:14px;top:12px;width:34px;height:34px;border:0;background:transparent;font-size:26px;line-height:1;color:#8B5442;cursor:pointer}',
    '.avc-scroll{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch}',
    '.avc-ship{text-align:center;font-weight:800;font-size:14px;color:#5C3A2E;padding:0 16px 10px}',
    '.avc-ship span{color:#2E7D54}',
    '.avc-prog{padding:4px 20px 18px}',
    '.avc-bar{position:relative;height:6px;background:#EFE0D7;border-radius:999px;margin:18px 0 10px}',
    '.avc-fill{position:absolute;left:0;top:0;bottom:0;background:#8B5442;border-radius:999px;transition:width .4s ease}',
    '.avc-dot{position:absolute;top:50%;transform:translate(-50%,-50%);width:26px;height:26px;border-radius:50%;background:#EFE0D7;display:flex;align-items:center;justify-content:center}',
    '.avc-dot.on{background:#8B5442}',
    '.avc-dot svg{width:13px;height:13px;stroke:#fff;fill:none;stroke-width:2}',
    '.avc-dot:not(.on) svg{stroke:#B79A8C}',
    '.avc-labels{display:flex;justify-content:space-between;gap:8px}',
    '.avc-lab{flex:1 1 0;text-align:center;font-size:11.5px;line-height:1.3;color:#8A6555}',
    '.avc-lab b{display:block;font-size:12.5px;color:#5C3A2E}',
    '.avc-lab.on b{color:#8B5442}',
    '.avc-items{border-top:1px solid #F0E2D9}',
    '.avc-it{display:flex;gap:12px;padding:14px 16px;border-bottom:1px solid #F0E2D9;align-items:flex-start}',
    '.avc-it img{width:74px;height:74px;object-fit:cover;border-radius:10px;flex:0 0 auto;background:#F3E7E0}',
    '.avc-it-b{flex:1 1 auto;min-width:0}',
    '.avc-it-t{display:flex;align-items:center;gap:8px;font-weight:800;color:#5C3A2E;font-size:15px;line-height:1.25}',
    '.avc-del{border:0;background:transparent;cursor:pointer;padding:2px;flex:0 0 auto}',
    '.avc-del svg{width:17px;height:17px;stroke:#A8806E;fill:none;stroke-width:1.7}',
    '.avc-row{display:flex;align-items:center;gap:12px;margin-top:10px;flex-wrap:wrap}',
    '.avc-qty{display:flex;align-items:center;gap:12px;border:1px solid #E0CBBF;border-radius:999px;padding:4px 6px}',
    '.avc-qty button{width:26px;height:26px;border:0;border-radius:50%;background:#F3E7E0;color:#8B5442;font-size:16px;line-height:1;cursor:pointer}',
    '.avc-qty span{min-width:16px;text-align:center;font-weight:700;color:#5C3A2E}',
    '.avc-old{color:#A8806E;text-decoration:line-through;font-size:13px}',
    '.avc-new{font-weight:800;color:#5C3A2E}',
    '.avc-up{padding:16px}',
    '.avc-up h3{margin:0 0 10px;font-size:15px;font-weight:800;color:#5C3A2E}',
    '.avc-up-track{display:flex;gap:10px;overflow-x:auto;scrollbar-width:none;padding-bottom:4px}',
    '.avc-up-track::-webkit-scrollbar{display:none}',
    '.avc-up-card{flex:0 0 63%;max-width:230px;display:flex;align-items:center;gap:8px;background:#fff;border:1px solid #F0E2D9;border-radius:14px;padding:8px;position:relative}',
    '.avc-up-card.pin{border-color:#8B5442}',
    '.avc-up-card img{width:52px;height:52px;object-fit:cover;border-radius:8px;background:#F3E7E0;flex:0 0 auto}',
    '.avc-up-card b{display:block;font-size:13px;color:#5C3A2E;line-height:1.2;padding-right:30px}',
    '.avc-up-card span{font-size:12.5px;color:#8A6555}',
    '.avc-up-add{position:absolute;right:8px;bottom:8px;width:28px;height:28px;border-radius:50%;border:0;background:#8B5442;color:#fff;font-size:18px;line-height:1;cursor:pointer}',
    '.avc-ft{flex:0 0 auto;background:#8B5442;color:#fff;padding:16px 16px calc(16px + env(safe-area-inset-bottom));border-radius:22px 22px 0 0}',
    '.avc-promo{display:flex;align-items:center;justify-content:space-between;font-weight:800;font-size:15px;cursor:pointer;padding:2px 0 10px}',
    '.avc-promo span{font-size:22px;line-height:1}',
    '.avc-promo-box{display:none;gap:8px;padding-bottom:10px}',
    '.avc-promo-box.is-on{display:flex}',
    '.avc-promo-box input{flex:1 1 auto;min-width:0;border:0;border-radius:999px;padding:11px 14px;font:inherit;font-size:14px}',
    '.avc-promo-box button{border:0;border-radius:999px;padding:11px 16px;font:inherit;font-weight:800;background:#FDF6F1;color:#8B5442;cursor:pointer}',
    '.avc-msg{font-size:12.5px;padding-bottom:8px;opacity:.95}',
    '.avc-line{display:flex;justify-content:space-between;font-size:14px;padding:3px 0}',
    '.avc-tot{display:flex;justify-content:space-between;font-size:17px;font-weight:800;padding:6px 0 12px}',
    '.avc-co{display:block;width:100%;border:0;border-radius:999px;background:#FDF6F1;color:#8B5442;font:inherit;font-weight:800;font-size:17px;padding:16px;cursor:pointer;text-align:center;text-decoration:none}',
    '.avc-re{text-align:center;font-size:12px;font-weight:700;padding:10px 0 8px;opacity:.95}',
    '.avc-pay{display:flex;flex-wrap:wrap;gap:5px;justify-content:center}',
    '.avc-pay i{font-style:normal;background:#FDF6F1;color:#5C3A2E;border-radius:5px;font-size:9.5px;font-weight:800;padding:4px 6px;letter-spacing:.02em}',
    '.avc-empty{text-align:center;padding:40px 20px;color:#8A6555}'
  ].join('');

  var CHECK = '<svg viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TRASH = '<svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var ov, panel, scroll, footer, busy = false;

  function euro(c) {
    return (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function thumb(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function killThemeDrawer() {
    var t = d.querySelector('theme-drawer#cart-drawer');
    if (!t) return;
    try { if (typeof t.close === 'function') t.close(); } catch (e) {}
    t.removeAttribute('open');
  }

  function ensure() {
    if (panel) return;
    var st = d.createElement('style');
    st.textContent = CSS;
    d.head.appendChild(st);

    ov = d.createElement('div');
    ov.className = 'avc-ov';
    ov.addEventListener('click', close);

    panel = d.createElement('aside');
    panel.className = 'avc';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Panier');
    panel.innerHTML =
      '<div class="avc-hd"><h2></h2><button class="avc-x" aria-label="Fermer">×</button></div>' +
      '<div class="avc-scroll"></div>' +
      '<div class="avc-ft"></div>';
    panel.querySelector('.avc-x').addEventListener('click', close);

    d.body.appendChild(ov);
    d.body.appendChild(panel);
    scroll = panel.querySelector('.avc-scroll');
    footer = panel.querySelector('.avc-ft');

    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function open() {
    ensure();
    killThemeDrawer();
    ov.classList.add('is-on');
    panel.classList.add('is-on');
    d.documentElement.style.overflow = 'hidden';
    load();
    setTimeout(killThemeDrawer, 60);
  }

  function close() {
    if (!panel) return;
    ov.classList.remove('is-on');
    panel.classList.remove('is-on');
    d.documentElement.style.overflow = '';
    killThemeDrawer();
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function bubble(n) {
    var b = d.querySelector('#cart-bubble-text');
    if (b) b.textContent = n;
  }

  function progress(cart) {
    var money = cart.total_price;
    var qty = cart.item_count;
    var shipOk = money >= FREE_SHIP;
    var bundleOk = qty >= BUNDLE_QTY;
    var pct = shipOk ? (bundleOk ? 100 : 50 + Math.min(50, (qty / BUNDLE_QTY) * 50)) : Math.min(50, (money / FREE_SHIP) * 50);

    var head = shipOk
      ? '<span>✓ Livraison offerte débloquée</span>'
      : 'Plus que <b>' + euro(FREE_SHIP - money) + '</b> pour la livraison offerte';

    return '<div class="avc-ship">' + head + '</div><div class="avc-prog">' +
      '<div class="avc-bar"><div class="avc-fill" style="width:' + pct + '%"></div>' +
        '<div class="avc-dot' + (shipOk ? ' on' : '') + '" style="left:50%">' + CHECK + '</div>' +
        '<div class="avc-dot' + (bundleOk ? ' on' : '') + '" style="left:100%">' + CHECK + '</div>' +
      '</div><div class="avc-labels">' +
        '<div class="avc-lab' + (shipOk ? ' on' : '') + '"><b>Livraison offerte</b>' + (shipOk ? 'Débloquée' : 'dès ' + euro(FREE_SHIP)) + '</div>' +
        '<div class="avc-lab' + (bundleOk ? ' on' : '') + '"><b>2ᵉ kit à −15 %</b>' + (bundleOk ? 'Débloqué' : 'dès 2 kits') + '</div>' +
      '</div></div>';
  }

  function itemsHtml(cart) {
    if (!cart.items.length) return '<div class="avc-empty">Votre panier est vide.</div>';
    return '<div class="avc-items">' + cart.items.map(function (it, i) {
      var old = it.original_line_price > it.final_line_price
        ? '<span class="avc-old">' + euro(it.original_line_price) + '</span>' : '';
      return '<div class="avc-it" data-line="' + (i + 1) + '">' +
        '<img src="' + thumb(it.image, 160) + '" alt="" decoding="async">' +
        '<div class="avc-it-b">' +
          '<div class="avc-it-t"><span>' + it.product_title + '</span>' +
            '<button class="avc-del" data-line="' + (i + 1) + '" aria-label="Retirer">' + TRASH + '</button></div>' +
          '<div class="avc-row"><div class="avc-qty">' +
            '<button data-q="-" data-line="' + (i + 1) + '" aria-label="Moins">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button data-q="+" data-line="' + (i + 1) + '" aria-label="Plus">+</button>' +
          '</div>' + old + '<span class="avc-new">' + euro(it.final_line_price) + '</span></div>' +
        '</div></div>';
    }).join('') + '</div>';
  }

  function footerHtml(cart) {
    var disc = (cart.cart_level_discount_applications || []).map(function (x) {
      return '<div class="avc-line"><span>' + x.title + '</span><span>−' + euro(x.total_allocated_amount) + '</span></div>';
    }).join('');
    var saved = cart.original_total_price - cart.total_price;
    if (!disc && saved > 0) {
      disc = '<div class="avc-line"><span>Remises</span><span>−' + euro(saved) + '</span></div>';
    }
    return '<div class="avc-promo">Ajouter un code promo<span>+</span></div>' +
      '<form class="avc-promo-box"><input type="text" name="code" placeholder="Votre code" autocomplete="off"><button type="submit">Appliquer</button></form>' +
      '<div class="avc-msg" hidden></div>' + disc +
      '<div class="avc-tot"><span>Sous-total</span><span>' + euro(cart.total_price) + '</span></div>' +
      '<a class="avc-co" href="/checkout">Passer commande</a>' +
      '<div class="avc-re">Retours 30 jours · Pièce manquante remplacée sous 48 h</div>' +
      '<div class="avc-pay">' + PAY.map(function (p) { return '<i>' + p + '</i>'; }).join('') + '</div>';
  }

  function recs(pid, intent) {
    return fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { return j.products || []; })
      .catch(function () { return []; });
  }

  function pinnedProduct() {
    return fetch('/products/' + PIN + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? [p] : []; })
      .catch(function () { return []; });
  }

  function card(p, isPin) {
    var vid = p.variants && p.variants[0] ? p.variants[0].id : null;
    if (!vid) return '';
    var img = p.featured_image || (p.images && p.images[0]) || '';
    return '<div class="avc-up-card' + (isPin ? ' pin' : '') + '">' +
      '<img src="' + thumb(img, 120) + '" alt="" decoding="async">' +
      '<div><b>' + p.title + '</b><span>' + euro(p.price) + '</span></div>' +
      '<button class="avc-up-add" data-vid="' + vid + '" aria-label="Ajouter ' + p.title + '">+</button></div>';
  }

  function upsell(cart) {
    if (!cart.items.length) return Promise.resolve('');
    var pid = cart.items[0].product_id;
    var have = cart.items.map(function (i) { return i.product_id; });

    return Promise.all([
      pinnedProduct(),
      recs(pid, 'complementary').then(function (l) { return l.length ? l : recs(pid, 'related'); })
    ]).then(function (res) {
      var pin = res[0].filter(function (p) { return have.indexOf(p.id) === -1 && p.available !== false; });
      var pinIds = pin.map(function (p) { return p.id; });
      var rest = res[1].filter(function (p) {
        return have.indexOf(p.id) === -1 && pinIds.indexOf(p.id) === -1 && p.available !== false;
      }).slice(0, 6);

      var html = pin.map(function (p) { return card(p, true); }).join('') +
                 rest.map(function (p) { return card(p, false); }).join('');
      if (!html) return '';
      return '<div class="avc-up"><h3>Vous aimerez aussi</h3><div class="avc-up-track">' + html + '</div></div>';
    }).catch(function () { return ''; });
  }

  function render(cart) {
    panel.querySelector('.avc-hd h2').textContent = 'Votre panier (' + cart.item_count + ')';
    bubble(cart.item_count);
    scroll.innerHTML = progress(cart) + itemsHtml(cart);
    footer.innerHTML = footerHtml(cart);
    upsell(cart).then(function (html) {
      if (html && panel.classList.contains('is-on')) scroll.insertAdjacentHTML('beforeend', html);
    });
  }

  function load() {
    return getCart().then(render).catch(function () {});
  }

  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : (e.target ? e.target.parentElement : null);
    if (!t || !t.closest) return;

    var promo = t.closest('.avc-promo');
    if (promo) { panel.querySelector('.avc-promo-box').classList.toggle('is-on'); return; }

    var del = t.closest('.avc-del');
    var q = t.closest('[data-q]');
    var up = t.closest('.avc-up-add');
    if (!del && !q && !up) return;

    e.preventDefault();
    if (busy) return;
    busy = true;

    var job;
    if (del) {
      job = post('/cart/change.js', { line: +del.getAttribute('data-line'), quantity: 0 });
    } else if (q) {
      var line = +q.getAttribute('data-line');
      var cur = +q.parentElement.querySelector('span').textContent;
      var next = q.getAttribute('data-q') === '+' ? cur + 1 : cur - 1;
      job = post('/cart/change.js', { line: line, quantity: Math.max(0, next) });
    } else {
      job = post('/cart/add.js', { id: +up.getAttribute('data-vid'), quantity: 1 });
    }
    job.then(load).catch(function () {}).then(function () { busy = false; });
  });

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;

    if (f.classList && f.classList.contains('avc-promo-box')) {
      e.preventDefault();
      var code = (f.code.value || '').trim();
      if (!code) return;
      fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' })
        .then(function () { return getCart(); })
        .then(function (cart) {
          var ok = (cart.cart_level_discount_applications || []).length > 0 ||
                   cart.original_total_price > cart.total_price;
          render(cart);
          var m = panel.querySelector('.avc-msg');
          if (m) { m.hidden = false; m.textContent = ok ? 'Code appliqué.' : 'Ce code ne s’applique pas à ce panier.'; }
        })
        .catch(function () {
          var m = panel.querySelector('.avc-msg');
          if (m) { m.hidden = false; m.textContent = 'Code impossible à vérifier.'; }
        });
      return;
    }

    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') !== 0) return;

    e.preventDefault();
    e.stopPropagation();

    var btn = f.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : null;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout en cours…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(f),
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        open();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        f.submit();
      });
  }, true);

  d.addEventListener('click', function (e) {
    var o = e.target && e.target.closest ? e.target.closest('button[aria-controls="cart-drawer"], a[href="/cart"]') : null;
    if (!o) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  window.AEVORA_CART = { open: open, close: close, refresh: load };
})();
